module.exports = __webpack_public_path__ + "static/media/  (87).f464988d.jpg";